e.S = e.Subscriptions = {
	init : function(){
		e.S.button.init();
		e.S.available_subscriptions.init();
	}
};